class Op {
  // { value, op }
  static shouldRun () {
    return true
  }
}

export default Op
